import { Notifications, Registered, RegistrationError } from 'react-native-notifications'
import { updatePush } from './updatePush'
import { PlatformType } from '../GlobalTypes'
import { Alert, Platform } from 'react-native'
import { setGlobal, setGlobalAndPersist } from '../../global/useGlobal'
import { updateSendNotification } from './updateSendNotification'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'

const requestPermission = () => {
  Alert.alert(
    formatMessage(messages.push_alert_title),
    formatMessage(messages.push_alert_message),
    [
      {
        text: formatMessage(messages.push_alert_deny),
        onPress: async () => {
          await updateSendNotification({ sendNotifications: false })
          await setGlobalAndPersist({ requestPermissionToSendPush: true })
        },
      },
      {
        text: formatMessage(messages.push_alert_allow),
        onPress: async () => {
          await updateSendNotification({ sendNotifications: true })
          await setGlobalAndPersist({ requestPermissionToSendPush: true })
        },
      },
    ],
    { cancelable: false }
  )
}

export const setDeviceToken = async () => {
  Notifications.events().registerRemoteNotificationsRegistered((event: Registered) => {
    onPushRegistered(event.deviceToken)
  })
}

export const setupNotifications = async requestPermissionToSendPush => {
  Notifications.registerRemoteNotifications()

  Notifications.events().registerRemoteNotificationsRegistered((event: Registered) => {
    onPushRegistered(event.deviceToken)
    if (Platform.OS === 'ios') {
      updatePush({ deviceToken: event.deviceToken, platformApplication: PlatformType.ios })
    } else {
      !requestPermissionToSendPush && requestPermission()
      updatePush({ deviceToken: event.deviceToken, platformApplication: PlatformType.android })
    }
  })

  Notifications.events().registerRemoteNotificationsRegistrationFailed((event: RegistrationError) => {
    console.error(event)
  })

  Notifications.ios.checkPermissions().then(currentPermissions => {
    if (!!currentPermissions.alert) {
      updateSendNotification({ sendNotifications: true })
      setGlobalAndPersist({ requestPermissionToSendPush: true })
    } else {
      updateSendNotification({ sendNotifications: false })
      setGlobalAndPersist({ requestPermissionToSendPush: true })
    }
  })
}

const onPushRegistered = async (deviceToken: string) => {
  await setGlobal({
    pushToken: deviceToken,
  })
}
